export const KNOWN_RUNTIME_GLOBALS = [
  "AggregateError",
  "Array",
  "Boolean",
  "Error",
  "isFinite",
  "isNaN",
  "JSON",
  "Map",
  "Math",
  "Number",
  "Object",
  "parseFloat",
  "parseInt",
  "Promise",
  "RangeError",
  "ReferenceError",
  "RegExp",
  "Set",
  "String",
  "structuredClone",
  "SyntaxError",
  "TypeError",
  "console"
] as const;
